export const environment = {
  production: true,
  apiKey: 'ff744e09-9d5e-11e6-8145-0800274f2cef',
  apiRoot: 'https://apicompany.dreamjobs.com.co/v1',
  landing: 'https://user.dreamjobs.com.co/job/',
  apiGoogleKey: 'AIzaSyDiDWCREgYDr71JzCDISN5-CRC8LleVS1M',
};



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/environments/environment.ts